import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import ClLoginModal from '../components/Modal/ClLoginModal/ClLoginModal';
import PageContainer from './PageContainer';
import styles from './ListOnOnthehouse.scss';
import {CODE_VERIFIER, generateCodeVerifier, redirectToPF} from '../lib/pkceUtils';
import {trackAgencyJoinWizard} from '../lib/tracking';

const ListOnOnthehouse = (props) => {
  const {
    history,
    location: {
      search: searchString = '',
    } = {},
  } = props;
  const [expandList, setExpandList] = useState(true);
  const [showModal, setShowModal] = useState(false);

  const agencyJoinUrl = searchString.length > 0 ? `/agency-create-account${searchString}` : '/agency-create-account';

  useEffect(() => {
    if(window?.oth_device === 'phone') setExpandList(false);
    trackAgencyJoinWizard('Landing Page', 'not available');
  }, []);

  const toggleList = () => {
    setExpandList(!expandList);
  };

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const hasClAccountButtonHandler = () => {
    const codeVerifier = generateCodeVerifier();
    localStorage.setItem(CODE_VERIFIER, codeVerifier);
    localStorage.setItem('JOIN_SEARCH_STRING', searchString);
    redirectToPF(process.env.AGENCY_JOIN_REDIRECT_URL, codeVerifier);
  };

  const handleGetStartedClick = () => {
    toggleModal();
    trackAgencyJoinWizard('Get Started', 'not available');
  };

  return (
    <PageContainer>
      <Helmet>
        <title>List for free with onthehouse.com.au!</title>
      </Helmet>

      <div className="d-flex justify-content-center">
        <div className={styles.getStartedContainer}>
          <h1 className={styles.headerText}>
            Sign up to start listing on
            <br/>OnTheHouse.com.au
          </h1>

          <div className="mt-5 mb-4 d-flex" id="body">
            <div>
              <p className="font-weight-bold">Get your listings in front of more buyers & vendors for ZERO cost</p>
              <p>
              With a large user base of 1.5 million visitors* and coverage of 98% of the Australian property market, OnTheHouse is the home of property research for buyers, sellers and homeowners.
              </p>
              {
                expandList ?
                  <ul className="mb-0">
                    <li><span className="font-weight-bold">It’s free:</span> List your rental & sale properties for zero
                      cost
                    </li>
                    <li><span className="font-weight-bold">It’s easy:</span> Upload your properties automatically via your
                      CRM so there’s no extra effort involved
                    </li>
                    <li><span className="font-weight-bold">Attract buyers and vendors:</span> Access a huge & loyal user
                      base of current property owners to not only attract potential buyers, but also build brand exposure
                      to help secure new listings
                    </li>
                    <li><span className="font-weight-bold">We’re owned and operated by Cotality:</span> Your listed
                      properties will also flow through to other Cotality products like RP Data.
                    </li>
                  </ul>
                  : <span id="expandList" className={styles.link} onClick={toggleList}>Why list on OnTheHouse.com.au?<br /></span>
              }
              <br />
              <p className="font-weight-bold">Signing up is simple</p>
              <p>
                Sign up online in less than 5 minutes. We’ll then reach out to your CRM to enable
                OnTheHouse for you, and let you know once you’re ready to start listing.
              </p>
              <p>Looking to sign up multiple offices for OnTheHouse? <a href="/agent-contact?enquiryType=agencySignup" rel="nofollow">Submit a request online</a></p>
              <br />
              <p className={`${styles.smallText} ${styles.grayText}`}>*Google Analytics - Monthly users on OnTheHouse.com.au - January 2023</p>
              <p className={`${styles.smallText} ${styles.grayText}`}>See OnTheHouse agency membership <Link to="/agency-terms-conditions" target="_blank">terms and conditions</Link></p>
            </div>
            <img
              className={styles.joinImage}
              src="/assets/images/agency/agency-join-2.svg"
            />
          </div>
          <div className="d-flex flex-column">
            <div className="d-flex justify-content-center mb-5">
              <button className={'odinButton ' + styles.button} onClick={handleGetStartedClick}>Get Started</button>
            </div>
            <div className={styles.divider} />
            <div className="d-flex flex-column align-items-center">
              <p className="mt-4 font-weight-bold">Already Registered?</p>
              <div className={`${styles.button} odinButton`}>
                <a className="odinButton text-center p-0" href={process.env.AGENT_CENTRE} target="_self" rel="nofollow noopener">
                  Sign in to Agent Centre
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ClLoginModal
        showModal={showModal}
        toggleModal={toggleModal}
        noClAccountButtonHandler={() => history.push(agencyJoinUrl)}
        hasClAccountButtonHandler={hasClAccountButtonHandler}
      />
    </PageContainer>
  );
};

ListOnOnthehouse.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
};

export default withRouter(ListOnOnthehouse);
